import React from "react";
import {
  CssBaseline,
  Typography,
  Container,
  Grid,
  Avatar
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import bobby from "./Images/bobby.jpg";
import heather from "./Images/heather.jpg";
import kristine from "./Images/kristine.jpg";
import lily from "./Images/lily.jpg";
import mike from "./Images/mike.jpg";
import edwin from "./Images/edwin.jpg";
import holly from "./Images/holly.jpg";
import doug from "./Images/doug.jpg";
import bart from "./Images/bart.jpg";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/about");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 500
  },
  route: {
    marginTop: theme.spacing(6),
    position: "relative",
    minHeight: "84vh"
  },
  bios: {
    flexGrow: 1
  },
  large: {
    width: theme.spacing(14),
    height: theme.spacing(14)
  }
}));

const bios = [
  {
    photo: bart,
    name: "Bart(holomew)",
    title: "Operations Expert",
    department: "Canis Lupus Familiaris",
    email: "GMtechops@carat.com",
    bio: "About Bart"
  },
  {
    photo: bobby,
    name: "Bobby Bens",
    title: "Systems Development Architect",
    department: "Data & Tech Ops",
    email: "bobby.bens@dentsuaegis.com",
    bio: "About Bobby"
  },
  {
    photo: holly,
    name: "Holly Champoux",
    title: "Director",
    department: "Digital Ad Ops",
    email: "holly.champoux@carat.com",
    bio: "About Holly"
  },
  {
    photo: mike,
    name: "Mike D'Orazio",
    title: "Associate Director",
    department: "Data & Tech Ops",
    email: "mike.dorazio@carat.com",
    bio: "About Mike"
  },
  {
    photo: kristine,
    name: "Kristine Gillette",
    title: "Supervisor",
    department: "Global Ad Ops & Tech",
    email: "kristine.gillette@carat.com",
    bio: "About Kristine"
  },
  {
    photo: edwin,
    name: "Edwin Leung",
    title: "VP, Technical Architect",
    department: "Data & Tech Ops",
    email: "edwin.leung@carat.com",
    bio: "About Edwin"
  },
  {
    photo: doug,
    name: "Douglas Schuster",
    title: "Developer",
    department: "Data & Tech Ops",
    email: "douglas.schuster@carat.com",
    bio: "About Douglas"
  },
  {
    photo: lily,
    name: "Lily Seifu",
    title: "Sr. Systems Analyst",
    department: "Data & Tech Ops",
    email: "lily.seifu@dentsuaegis.com",
    bio: "About Lily"
  },
  {
    photo: heather,
    name: "Heather Wenzel",
    title: "Developer",
    department: "Data & Tech Ops",
    email: "heather.wenzel@carat.com",
    bio: "About Heather"
  }
];

export default function About() {
  const classes = useStyles();

  return (
    <div className={classes.route}>
      <CssBaseline />
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom>
          About
        </Typography>
        <Typography variant="body1" gutterBottom style={{ marginBottom: 40 }}>
          Bart was developed to standardize, streamline and simplify the
          creative naming and submission process.
        </Typography>
        <div className={classes.bios}>
          <Grid container spacing={6}>
            {bios.map((bio) => (
              <Grid item xs={4}>
                <Avatar
                  alt=""
                  src={bio.photo}
                  className={classes.large}
                  style={{ marginBottom: 20 }}
                />
                <Typography variant="body1" gutterBottom>
                  {bio.name}
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  color="textSecondary"
                >
                  {bio.title},<br />
                  {bio.department}
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  color="textSecondary"
                >
                  {bio.email}
                </Typography>
                {/* <Typography variant="body1" gutterBottom>
                  {bio.bio}
                </Typography> */}
              </Grid>
            ))}
          </Grid>
        </div>
      </Container>
    </div>
  );
}
